import { styled } from '../../../utils/styled'
import type { CSSObject } from '../../theme/themeTypes'
import { Tab } from '@mui/material'
import { type AdornmentPosition } from './types'

const calculatePadding = (adornmentPosition?: AdornmentPosition): string => {
  switch (adornmentPosition) {
    case 'left':
      return '8px 16px 8px 8px'
    case 'right':
      return '8px 8px 8px 16px'
    default:
      return '8px 16px'
  }
}

export const StyledTab = styled(Tab, {
  shouldForwardProp: (prop) => prop !== 'adornmentPosition'
})<{ adornmentPosition?: AdornmentPosition }>(
  ({ theme, adornmentPosition }): CSSObject => ({
    fontFamily: theme.typography.h5.fontFamily,
    textTransform: 'initial',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: '40px',
    borderRadius: theme.borderRadius.medium,
    gap: '4px',
    padding: calculatePadding(adornmentPosition),
    div: {
      alignSelf: 'center'
    },
    color: theme.tokens.foreground.main.primary,
    '&.Mui-disabled': {
      color: theme.tokens.foreground.main.disabled
    }
  })
)

export const StyledSpanDisabled = styled('span')({
  display: 'inline-flex',
  cursor: 'not-allowed'
})

export const StyledSpan = styled('span')({
  display: 'inline-flex'
})
